"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var viewports = exports.viewports = {
  xsmall: 0,
  small: 601,
  medium: 961,
  large: 1281,
  xlarge: 1681
};

exports.default = viewports;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/ViewportManager/viewports.js